import _ from 'lodash';
import LoadingScreen from 'src/minimals/LoadingScreen';
import { useSelector } from 'react-redux';
import { generatePath, Navigate } from 'react-router';
import {
  currentWorkspaceSelectors,
  uiSelectors,
  userSelectors,
  workspaceSelectors,
} from 'src/selectors';
import { PATH_AUTH, PATH_PAGE, PATH_WORKSPACE } from './paths';

const RouteSolver = () => {
  const isAuthenticated = useSelector(userSelectors.isAuth());
  const isWorkspaceLoading = useSelector(
    workspaceSelectors.isWorkspaceLoading()
  );
  const currentWorkspaceId = useSelector(
    currentWorkspaceSelectors.getCurrentWorkspaceId()
  );

  const cameFromInvitation = useSelector(
    workspaceSelectors.cameFromInvitation()
  );

  const invitationInfo = useSelector(workspaceSelectors.getInvitationInfo());

  const isLoggedAsCustomer = useSelector(uiSelectors.isLoggedAsCustomer);

  if (!isAuthenticated) {
    return <Navigate to={PATH_AUTH.login} />;
  }

  if (isWorkspaceLoading) {
    return <LoadingScreen />;
  }

  if (cameFromInvitation) {
    // TODO: refactorizar las invitaciones para generalizar
    if (invitationInfo.workspaceId) {
      return (
        <Navigate to={PATH_PAGE.workspaceInvitation} state={invitationInfo} />
      );
    }

    if (invitationInfo.customerId) {
      return (
        <Navigate
          to={`${PATH_PAGE.customerInvitation}/accept`}
          state={invitationInfo}
        />
      );
    }
  }
  if (isLoggedAsCustomer) {
    return <Navigate to={PATH_PAGE.customer} />;
  }
  if (_.isEmpty(currentWorkspaceId)) {
    return <Navigate to={PATH_PAGE.workspaces} />;
  }

  return (
    <Navigate
      to={generatePath(PATH_WORKSPACE.dashboard, {
        workspaceId: currentWorkspaceId,
      })}
    />
  );
};

export default RouteSolver;
